import { render } from "./OurServicesMainPage.vue?vue&type=template&id=14a294a0"
import script from "./OurServicesMainPage.vue?vue&type=script&lang=js"
export * from "./OurServicesMainPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__